import { render, staticRenderFns } from "./FormContenedor.vue?vue&type=template&id=4843056f"
import script from "./FormContenedor.vue?vue&type=script&lang=js"
export * from "./FormContenedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports